export const Arrow = () => {
  return (
    <svg
      width="10"
      height="18"
      viewBox="0 0 10 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.501797 9.06919C0.516953 9.36236 0.625377 9.64056 0.809568 9.85764L7.37568 17.5224C7.58204 17.7968 7.88515 17.969 8.21277 17.9964C8.54155 18.0226 8.86565 17.9041 9.10931 17.6671C9.35298 17.4301 9.49406 17.0957 9.49988 16.7427C9.50454 16.3909 9.37396 16.0516 9.13847 15.8058L3.30926 8.99954L9.13847 2.19326C9.37398 1.9475 9.50456 1.60943 9.49988 1.25638C9.49405 0.904566 9.35298 0.570256 9.10931 0.333225C8.86565 0.0949508 8.54155 -0.0235671 8.21277 0.00389814C7.88515 0.0313436 7.58204 0.202251 7.37568 0.476715L0.809568 8.14144C0.595051 8.39469 0.484307 8.72901 0.501797 9.06957V9.06919Z"
        fill="#173B33"
      />
    </svg>
  );
};
